module.exports = "/images/u.png?ed7c21ab0382a141d4e05a90ca8b463a";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/img/u.png
// module id = Ld+O
// module chunks = 70